module.exports = __webpack_public_path__ + "img/headshot-daniela-mazal@2x.e9a36092.jpg";